/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TalentPoolTransferRequestMode } from './talentPoolTransferRequestMode';

export interface TalentPoolTransferRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  profile_ids: string[];
  target_pool_id: string;
  mode: TalentPoolTransferRequestMode;
}
